import { Button, Card, Chip, darken, Dialog, DialogActions, Grid, lighten, List, ListItem, ListItemText, Menu, Paper, styled, SvgIcon, TableContainer, TablePagination, Typography } from "@mui/material";
import { Form } from "formik";
import FormikAutocomplete from "../commons/formik/FormikAutocomplete";
import FormikCheckbox from "../commons/formik/FormikCheckbox";
import CircularLoading from "../commons/loading/CircularLoading";
import { tableStyles } from "../commons/table/tableConfig";

export const StyledRgrl = {
    BreadcrumbContainer: styled("div")(({ theme }) => ({
        display: "flex",
        margin: "15px",
    })),
    GridContainer: styled("div")(({ theme }) => ({
        paddingRight: "35px",
        paddingLeft: "35px",
        paddingTop: "15px",
    })),
    RadioContainer: styled("div")(({ theme }) => ({
        marginTop: "10px",
        display: "flex",
        flexDirection: "column",
        marginLeft: "5px",
    })),
    PaddingContainer: styled(Grid)(({ theme }) => ({
        padding: "20px",
    })),
    TextInputGroupContainer: styled("div")(({ theme }) => ({
        marginTop: "25px",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        marginTop: "20px",
        display: "flex",
        justifyContent: "flex-end",
    })),
    ButtonAfterTableContainer: styled("div")(({ theme }) => ({
        marginTop: "20px",
    })),
    FormikInput: styled("div")(({ theme }) => ({
        margin: "20px",
    })),
    FormikRadio: styled("div")(({ theme }) => ({
        marginTop: "20px",
    })),
    FlexDirectionColumn: styled(Grid)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
    })),
    LoadingContainer: styled(Grid)(({ theme }) => ({
        height: "500px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    })),
    Titulo: styled(Typography)(({ theme }) => ({
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        padding: "5px",
        margin: "10px",
    })),
    Paper: styled("div")(({ theme }) => ({
        marginTop: "50px",
        padding: "10px",
        width: "80%",
        margin: "0 auto",
    })),
    PlanillaTableButtonContainer: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        padding: "10px",
    })),
    FormikGroup: styled("div")(({ theme }) => ({
        alignItems: "baseline",
    })),
    RadioButtonExtraLabel: styled(Typography)(({ theme }) => ({
        marginLeft: "28px",
        color: theme.palette.tertiary.main,
    })),
    Icon: styled(SvgIcon)(({ theme }) => ({
        marginLeft: 10,
    })),
    TableFooter: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    })),
    TableContainer: styled(TableContainer)(({ theme }) => ({
        border: `2px solid primary`,
    })),
    TableButtonContainer: styled("div")(({ theme }) => ({
        margin: "30px 25px 0px 0px",
        "& button": {
            marginLeft: 10,
        },
    })),
    MessageContainer: styled("div")(({ theme }) => ({
        minHeight: "150px",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    })),
    Input: styled(FormikAutocomplete)(({ theme }) => ({
        flex: 1,
    })),
    RowContainer: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        padding: "10px",
    })),
    List: styled(List)(({ theme }) => ({
        padding: 0,
    })),
    ListItem: styled(ListItem)(({ theme }) => ({
        padding: "5px",
        display: "flex",
        wordWrap: "break-word",
    })),
    Label: styled(Typography)(({ theme }) => ({
        marginRight: "15px",
    })),
}

export const StyledEstablecimientos = {
    PaperContainer: styled(Paper)(({ theme }) => ({
        padding: theme.spacing(2),
    })),
    ContentContainer: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        marginTop: "20px",
    })),
    ToolbarContainer: styled("div")(({ theme }) => ({
        width: "100%",
        display: "flex",
        alignItems: "start",
        justifyContent: "space-between",
    })),
    DatePickersContainer: styled("div")(({ theme }) => ({
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    })),
    DatePicker: styled("div")(({ theme }) => ({
        minWidth: "150px",
    })),
    VisibilityIcon: styled("span")(({ theme }) => ({
        color: theme.palette.primary.main,
    })),
    Menu: styled(Menu)(({ theme }) => ({
        marginLeft: 0,
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        display: "flex",
        margin: "10px",
    })),
    Card: styled(Paper)(({ theme }) => ({
        marginTop: 10,
        padding: 5,
        paddingLeft: 10,
        paddingRight: 10,
        borderRadius: 5,
    })),
    StickyCard: styled(Paper)(({ theme }) => ({
        position: "sticky",
        top: 0,
        padding: 10,
        ...tableStyles.headerStyle
    })),
    EmptyState: styled(Typography)(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "100px 20px 20px 50px",
        color: "grey",
        textAlign: "center",
    })),
    EstadoPrePresentado: styled("span")(({ theme }) => ({
        color: "#d52b34",
    })),
    EstadoRevision: styled(Typography)(({ theme }) => ({
        color: "#424db8",
    })),
    EstadoFinalizado: styled(Typography)(({ theme }) => ({
        color: "black",
    })),
    FormularioText: styled(Typography)(({ theme, estado }) => ({
        color: estado === 2 ? theme.palette.tertiary.main : "black",
    })),
    IconPadding: styled("span")(({ theme }) => ({
        paddingRight: 10,
    })),
    // Dialog
    AdjuntarFormularioDialog: styled(Dialog)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    })),
    LoadingContainer: styled("div")(({ theme }) => ({
        padding: 20,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    })),
    ContainerButtonsDialog: styled(DialogActions)(({ theme }) => ({
        display: "flex",
        justifyContent: "flex-end",
        backgroundColor: "white",
        boxShadow: "0px 0 5px lightGrey",
        paddingRight: 10,
        zIndex: 2,
    })),
    // Label
    GridItemAligned: styled(SvgIcon)(({ theme }) => ({
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: 10,
    })),
    GridRowItem: styled(Grid)(({ theme }) => ({
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
    })),
    PaperOutlined: styled(Paper)(({ theme }) => ({
        flex: 1,
        borderRadius: 5,
        borderStyle: "solid",
        borderColor: theme.palette.primary.main,
    })),
    HeaderDiv: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "space-between",
        padding: 8,
    })),
    List: styled(List)(({ theme }) => ({
        padding: 0,
    })),
    ListItem: styled(ListItem)(({ theme }) => ({
        padding: "5px",
        display: "flex",
        wordWrap: "break-word",
    })),
    Label: styled(Typography)(({ theme }) => ({
        fontWeight: 600,
        marginRight: "15px",
    })),
    ListItemText: styled(ListItemText)(({ theme }) => ({
        display: "flex",
        flex: "0 0 auto",
        margin: "5px",
        justifyContent: "space-evenly",
        width: "20%",
    })),
}

export const StyledNte = {
    BreadcrumbContainer: styled("div")(({ theme }) => ({
        margin: "15px",
        display: "flex",
    })),
    FormContainer: styled(Form)(({ theme }) => ({
        display: "flex",
        padding: "35px",
        width: "auto",
        alignItems: "center",
    })),
    Button: styled(Button)(({ theme }) => ({
        marginLeft: "20px",
        width: "80px",
    })),
    InputContainer: styled("div")(({ theme }) => ({
        width: "400px",
    })),
    Input: styled(FormikAutocomplete)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        width: "750px",
    })),
    // DatosDelEstablecimientoCard
    List: styled(List)(({ theme }) => ({
        padding: 0,
    })),
    ListItem: styled(ListItem)(({ theme }) => ({
        padding: "5px",
        display: "flex",
        wordWrap: "break-word",
    })),
    Label: styled(Typography)(({ theme }) => ({
        marginRight: "15px",
    })),
    // Form
    LoadingContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "300px",
    })),
    LoadingIcon: styled(CircularLoading)(({ theme }) => ({
        color: theme.palette.tertiary.main
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "flex-end",
        padding: "10px"
    })),
    Checkbox: styled(FormikCheckbox)(({ theme }) => ({
        marginLeft: "5px",
    })),
    // ImportarNomina
    TableFooter: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
    })),
    // Reponsables
    NewResponsableIconAligned: styled(Grid)(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    })),
}

export const StyledResolucion = {
    StyledChip: styled(Chip)({
        margin: "2px 4px",
        fontSize: "0.75rem",
        height: 24,
    }),
    EmptyText: styled(Typography)({
        fontSize: "0.85rem",
        color: "rgba(0, 0, 0, 0.5)",
        fontStyle: "Roboto, sans-serif !important",
    }),
    PuestoSelectorContainer: styled("div")(({ theme }) => ({
        display: "flex",
        alignItems: "center",
    })),
    BreadcrumbContainer: styled("div")(({ theme }) => ({
        display: "flex",
        margin: "15px",
    })),
    FormsContainer: styled("div")(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
    })),
    Form: styled(Form)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        width: "90%",
        rowGap: "15px",
    })),
    ButtonContainer: styled("div")(({ theme }) => ({
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        paddingBottom: "20px",
    })),
    CancelButton: styled(Button)(({ theme }) => ({
        backgroundColor: "#eb4034",
        color: "#f5f5f5",
        marginRight: "5px",
        ":hover": {
            backgroundColor: darken("#eb4034", 0.2),
        },
    })),
    // Table
    TableContainer: styled("div")(({ theme }) => ({
        paddingBottom: "1em",
        paddingRight: "1em",
        paddingLeft: "1em",
    })),
    TableFooter: styled("td")(({ theme }) => ({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    })),
    PaginationContainer: styled("div")(({ theme }) => ({
        display: "inline-block",
    })),
    AddIconContainer: styled("div")(({ theme }) => ({
        paddingLeft: "10em",
    })),
    HeaderContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "space-between", // Coloca el ícono en la esquina derecha
        alignItems: "center", // Alinea verticalmente
    })),
    TableTitle: styled(Typography)(({ theme }) => ({
        fontSize: "1.25rem",
        fontWeight: "bold",
    })),
    DeleteButton: styled(Button)(({ theme }) => ({
        marginLeft: "10px",
    })),
    AddButton: styled(Button)(({ theme }) => ({
        marginRight: "10px",
    })),
    TablePagination: styled(TablePagination)(({ theme }) => ({
        width: "fit-content"
    })),
    TableFooterButtonContainer: styled("div")(({ theme }) => ({
        marginRight: "10px",
    })),
    DialogGridContainer: styled(Grid)(({ theme }) => ({
        alignItems: "center",
    })),
    DialogGridItem: styled(Grid)(({ theme }) => ({
        padding: "15px",
    })),
    // Form
    GridContainer: styled(Grid)(({ theme }) => ({
        paddingRight: "35px",
        paddingLeft: "50px",
        paddingTop: "15px",
        alignItems: "center",
        justifyContent: "center",
    })),
    FullWidth: styled("div")(({ theme }) => ({
        width: "100%",
        alignItems: "center",
    })),
    RowContainer: styled(Grid)(({ theme }) => ({
        alignItems: "center",
        justifyContent: "center",
    })),
    PaddingContainer: styled(Grid)(({ theme }) => ({
        padding: "20px",
    })),
    FormikInput: styled("div")(({ theme }) => ({
        margin: "20px",
        marginTop: 0,
    })),
    LoadingContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "30vh",
        width: "100%",
    })),
    EquipoRadiologicoSelectorContainer: styled("div")(({ theme }) => ({
        display: "flex",
        alignItems: "center",
    })),
    // Cabecera
    DatosPresentacion: styled(Paper)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        border: `2px solid ${lighten("#a2a4a6", 0.65)}`,
        borderRadius: "20px",
        padding: "10px",
        width: "100%",
    })),
    FumarEstablecimiento: styled("div")(({ theme }) => ({
        alignItems: "center",
        justifyContent: "center",
        margin: "auto",
        display: "flex",
        backgroundColor: lighten("#a2a4a6", 0.85),
        borderRadius: "20px",
        padding: "10px",
    })),
    DatosResponsables: styled(Grid)(({ theme }) => ({
    })),
    ResponsableCard: styled(Card)(({ theme }) => ({
        padding: "20px",
    })),
    BotonAgregarResponsable: styled(Grid)(({ theme }) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    })),
    LabelActividad: styled(Typography)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        margin: "5px",
    })),
    Label: styled(Typography)(({ theme }) => ({
        margin: "5px",
    })),
    // ContratistasYEmpresas
    Container: styled("div")(({ theme }) => ({
        margin: "30px",
    })),
    MessageContainer: styled("div")(({ theme }) => ({
        minHeight: "150px",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    })),
    Pagination: styled(TablePagination)(({ theme }) => ({
        border: "none",
        boxShadow: "none",
    })),
    // Establecimiento
    CardsContainer: styled(Grid)(({ theme }) => ({
        padding: 20,
        margin: 10,
        width: "100%",
    })),
    Card: styled(Card)(({ theme }) => ({
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start"
    }))
}